import { Route, Routes } from "react-router";
import Profile from "../Pages/Profile";
import Requirements from "../Pages/Requirements/Index";
import SignIn from "../Pages/Signin";
import Signup from "../Pages/Signup";
import ProtectedRoute from "./ProtectedRoute";
import ProtectedLogin from "./ProtectedLogin";
import ForgotPassword from "../Pages/ForgotPassword/Index";
import ResetPassword from "../Pages/ResetPassword/Index";
import NotFound from "../Pages/NotFound/Index";
import ProviderLoader from "../Pages/ProviderLoader/ProviderLoader";
import InterviewRounds from "../Pages/InterviewRounds/index";
import JobPostListingPage from "../Pages/JobPostListing";
import SupabaseOAuthApproval from "../Pages/SupabaseOAuthApproval";
import { AIAssessmentProvider } from "../Context/AIAssessmentContext/AIAssessmentContext";
import { SimulationContextProvider } from "../Pages/SimulationRuntime/context/SimulationContext";
import SimulationRuntime from "../Pages/SimulationRuntime/SimulationRuntime";
import Layout from "../Components/Layout/Layout";
import CurrentApplicationLayout from "../Components/Layout/CurrentApplicationLayout";

const Routing = () => {
  return (
    <Routes>
      <Route
        path="/sign-in"
        element={
          <ProtectedLogin>
            <SignIn />
          </ProtectedLogin>
        }
      />
      <Route
        path="/sign-up"
        element={
          <ProtectedLogin>
            <Signup />
          </ProtectedLogin>
        }
      />
      <Route path="/provider" element={<ProviderLoader />} />
      <Route element={<Layout />}>
        <Route index element={<JobPostListingPage />} />
        <Route path="/:slug" element={<CurrentApplicationLayout />}>
          <Route path="requirements" element={<Requirements />} />
          <Route
            path="interview-round"
            element={
              <ProtectedRoute>
                <AIAssessmentProvider>
                  <InterviewRounds />
                </AIAssessmentProvider>
              </ProtectedRoute>
            }
          />
          <Route
            path="simulation"
            element={
              <ProtectedRoute>
                <SimulationContextProvider>
                  <SimulationRuntime />
                </SimulationContextProvider>
              </ProtectedRoute>
            }
          />
        </Route>
        <Route
          path="/test/approve-supabase-oauth"
          element={<SupabaseOAuthApproval />}
        />

        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />
      </Route>
      <Route
        path="/forgot-password"
        element={
          <ProtectedLogin>
            <ForgotPassword />
          </ProtectedLogin>
        }
      />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="*" element={<NotFound />} />
      <Route path="/notfound" element={<NotFound />} />
    </Routes>
  );
};

export default Routing;
